import I18n from 'I18n';
import { WarningInlineLabel } from './labelComponents/WarningInlineLabel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Map as ImmutableMap, fromJS } from 'immutable';
import { Metrics } from '../../monitoring/Metrics';
import { INLINE_LIMITED_DATA_INCORRECT_RENDER, INLINE_LIMITED_DATA_WARNING_LABEL_INTERACTION } from '../../constants/trackingMetrics';
// @ts-expect-error Untyped import
import { isSupportedCrmObjectIncludingHSDefined } from 'reporting-data/crmObjects/utils';
import { isCustomWidgetReport } from 'reporting-data/tsTypes/reportTypes';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import { TABLE } from 'reporting-data/constants/chartTypes';
import { getPrimaryDataDatasetData, getPrimaryDataDatasetPaginationSize, getPrimaryDataDatasetPaginationTotalHitCountMaybe } from 'reporting-data/v2/dataset/datasetGetters';
import { isReportResolveObject } from 'reporting-data/report/reportResolveUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const LIMITED_DATA_UNSUPPORTED_CHART_TYPES = [TABLE];
const getDatasetSize = reportResolveData => {
  if (!reportResolveData) {
    return undefined;
  }

  /**
   * Converts the reportResolveData to an Immutable Map to make it easier to
   * work with. This is necessary because the reportResolveData can be an
   * Immutable Map (Snowflake Resolve) or a plain object containing Immutable
   * Maps (Single Object Resolve).
   */
  const reportResolveDataImmutable = fromJS(reportResolveData);
  const datasetOrDatasetMap = reportResolveDataImmutable.get('data');
  const maybePrimaryDatasetData = getPrimaryDataDatasetData(datasetOrDatasetMap);

  // Single Object Dataset Size
  if (maybePrimaryDatasetData) {
    return maybePrimaryDatasetData.size;
  }

  // Snowflake Dataset Size
  if (datasetOrDatasetMap && maybePrimaryDatasetData === undefined) {
    return datasetOrDatasetMap.size;
  }
  return undefined;
};
export const condition = ({
  config,
  reportResolveData,
  report
}) => {
  if (reportResolveData === undefined) {
    return false;
  }
  const configDataType = config === null || config === void 0 ? void 0 : config.get('dataType');
  const isUnsupportedDataType = config && !isSupportedCrmObjectIncludingHSDefined(configDataType);
  const isCustomWidget = report && isCustomWidgetReport(report);
  const reportChartType = report && getReportChartType(report);
  const resolveDataObject = !isReportResolveObject(reportResolveData) && reportResolveData.toJS ? reportResolveData.toJS() : reportResolveData;
  const {
    data,
    paginationSize: maybeSnowflakePaginationSize
  } = resolveDataObject;
  if (!data || isUnsupportedDataType || isCustomWidget || LIMITED_DATA_UNSUPPORTED_CHART_TYPES.includes(reportChartType)) {
    return false;
  }
  const maybeSingleObjectPaginationSize = ImmutableMap.isMap(data) ? getPrimaryDataDatasetPaginationSize(data) : undefined;
  const paginationTotalHitCountMaybe = ImmutableMap.isMap(data) ? getPrimaryDataDatasetPaginationTotalHitCountMaybe(data) : undefined;
  const returnedDatasetSize = getDatasetSize(reportResolveData);
  if (paginationTotalHitCountMaybe) {
    const size = maybeSingleObjectPaginationSize !== null && maybeSingleObjectPaginationSize !== void 0 ? maybeSingleObjectPaginationSize : maybeSnowflakePaginationSize;
    return size !== undefined && size !== paginationTotalHitCountMaybe;
  }
  return returnedDatasetSize !== undefined && returnedDatasetSize < (maybeSingleObjectPaginationSize !== null && maybeSingleObjectPaginationSize !== void 0 ? maybeSingleObjectPaginationSize : maybeSnowflakePaginationSize);
};
const logUsage = event => {
  var _event$target;
  const isHovered = event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value;
  if (isHovered) {
    Metrics.counter(INLINE_LIMITED_DATA_WARNING_LABEL_INTERACTION).increment();
  }
};
export const render = ({
  reportResolveData
}) => {
  const datasetSize = getDatasetSize(reportResolveData);
  if (!datasetSize) {
    /**
     * We shouldn't hit the render() function if the dataset size is undefined
     * since condition() should return false. This is to help track if this
     * scenario ends up happening.
     */
    Metrics.counter(INLINE_LIMITED_DATA_INCORRECT_RENDER).increment();
    return undefined;
  }
  return /*#__PURE__*/_jsx(WarningInlineLabel, {
    tooltipProps: {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "settingLabels.limitedDataWarning.tooltip.message",
        options: {
          datasetSize
        }
      }),
      onOpenChange: event => logUsage(event)
    },
    inlineLabelBadgeText: I18n.text('settingLabels.limitedDataWarning.inlineLabel'),
    dataTestId: 'data-truncated-warning-label'
  });
};